import { ButtonBase, styled } from '@mui/material'

export const CardButton = styled(ButtonBase)<{
  component?: React.ElementType
  to?: string
  state?: unknown
}>(({ theme }) => ({
  padding: theme.spacing(2),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  fontSize: 18,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
}))
